module.exports = __webpack_public_path__ + "img/green-flag.6a025d28.svg";